import { render } from "./AsCourseCard.vue?vue&type=template&id=59864eae&scoped=true&ts=true"
import script from "./AsCourseCard.vue?vue&type=script&lang=ts"
export * from "./AsCourseCard.vue?vue&type=script&lang=ts"

import "./AsCourseCard.vue?vue&type=style&index=0&id=59864eae&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59864eae"]])

export default __exports__